export async function fetchRoute(start, end) {
  const [startLat, startLng] = start;
  const [endLat, endLng] = end;

  const res = await fetch("https://api.openrouteservice.org/v2/directions/driving-car/geojson", {
    method: "POST",
    headers: {
      "Authorization": "YOUR_API_KEY_HERE",  // Replace with your real API key
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      coordinates: [
        [startLng, startLat],
        [endLng, endLat],
      ],
    }),
  });

  const data = await res.json();
  const coords = data.features[0].geometry.coordinates.map(c => [c[1], c[0]]);
  const summary = data.features[0].properties.summary;

  return {
    coordinates: coords,
    distance: summary.distance,
    duration: summary.duration
  };
}
